<script lang="ts">
  import type { RecommendedProduct } from "../../../interfaces/RecommendationProduct";
  import ProductName from "../ProductDetails/ProductName.svelte";
  import ProductOptions from "../ProductDetails/ProductOptions.svelte";
  import ProductPrice from "../ProductDetails/ProductPrice.svelte";
  import ProductSingleImage from "../ProductDetails/ProductSingleImage.svelte";
  import ProductVendor from "../ProductDetails/ProductVendor.svelte";

  export let product: RecommendedProduct
  $: media = product?.media[0]
</script>

<div class="bundled-product-image">
  {#if media && (media.type === "image" || media.type === "image-set")}
    <!-- svelte-ignore a11y-missing-attribute -->
    <img {...(media.attributes)} class={$$props.class}/>
  {/if}
</div>
<div class="bundled-product-details">
  <ProductVendor {product} />
  <ProductName {product} />
  <ProductOptions {product} />
  <ProductPrice {product} />
</div>
